import * as actionTypes from "../actionTypes";
import * as ImmersionGQL from "../../../gql";

// creator onboarding get Success
const creatorOnBoardingGetSuccess = (items: any) => ({
  type: actionTypes.CREATOR_ON_BOARDING_GET_SUCCESS,
  payload: items,
});

// creator onboarding update Success
const creatorOnBoardingUpdateSuccess = (id: any, title: any, value: any) => ({
  type: actionTypes.CREATOR_ON_BOARDING_UPDATE_SUCCESS,
  payload: {
    id, title, value
  },
});

// creator onboarding move page
export const moveNextPage = (page: number) => ({
  type: actionTypes.CREATOR_ON_BOARDING_NEXT_PAGE,
  payload: page,
});

//get experience list
export const getCreatorOnboarding = (creatorOnBoarding: any, req: any) => {
  return (dispatch: any) => {
    creatorOnBoarding.query({
      query: ImmersionGQL.queryGetCreatorOnboarding,
      fetchPolicy: "no-cache",
      variables: { user_id: req.user_id?.toString() }
    })
      .then((response: any) => {
        if (response.data.getCreatorOnboarding) {
          dispatch(creatorOnBoardingGetSuccess(response.data.getCreatorOnboarding));
        }
      })
      .catch(() => {})
  }
};

export const updateCreatorOnboarding = (creatorOnBoarding: any, req: any) => {
  return (dispatch: any) => {
    const variables = {
      preference_id: req.preference_id,
      preference_name: req.preference_name,
      preference_information: req.preference_information,
      user_id: req.user_id
    }
    creatorOnBoarding.mutate({
      mutation: ImmersionGQL.mutationUpdateCreatorOnboarding,
      fetchPolicy: "no-cache",
      variables
    })
      .then(() => {
        dispatch(creatorOnBoardingUpdateSuccess(req.preference_id, req.preference_name, req.preference_information));
      }).catch(() => {

      })
  }
};

export const updateDepartment = (client: any, request: any, cb: any) => {
  return () => {
    const variables = { ...request };
    client.mutate({
      mutation: ImmersionGQL.mutationUpdateDepartment,
      fetchPolicy: "no-cache",
      variables
    }).then((res: any) => {
      if (cb) cb(res.data);
    }).catch(() => {
      if (cb) cb(null)
    })
  }
};

export const getBraintrustListForOnboardingSuccess = (res: any) => ({
  type: actionTypes.CREATOR_ONBOARDING_GET_BRAINTRUSTLIST_SUCCESS,
  payload: res
});

export const getBraintrustListForOnboarding = (experience: any) => {
  return (dispatch: any) => {
    const variables = {
    };
    experience.query({
      query: ImmersionGQL.mutationGetBraintrustList,
      fetchPolicy: "no-cache",
      variables
    })
      .then((res: any) => {
        if (res?.data?.getBraintrustList?.status === "true" && res?.data?.getBraintrustList?.data) {
          dispatch(getBraintrustListForOnboardingSuccess(res?.data?.getBraintrustList?.data))
        } else {
          dispatch(getBraintrustListForOnboardingSuccess([]))
        }
      }).catch(() => {
      dispatch(getBraintrustListForOnboardingSuccess([]));
    })
  }
};

export const validateSessionCodeForOnboarding = async (client: any, session_code: string) => {
  const req = {
    session_code: session_code
  };
  const variables = { ...req };
  return await client.query({
    query: ImmersionGQL.queryValidateSessionCode,
    fetchPolicy: "no-cache",
    variables
  });
};



export const updateOnBoardingSettings = (name: string, value: any) => ({
  type: actionTypes.UPDATE_ONBOARDING_SETTINGS,
  payload: { name, value }
});
